import{z}from"zod";import{otpValidator}from"../../../lib/validator/otp";export var OtpFormSchema=z.object({code:otpValidator});